import { validateTimeInput } from "../../../../utils";
import { BlueprintTestRunRequestErrorResponse } from "../../../../models/Blueprints";

export const getBlueprintTestRunErrorMessage = (
  value: string | BlueprintTestRunRequestErrorResponse
) => {
  if (typeof value === "string") {
    return value;
  }

  return Array.isArray(value.non_field_errors)
    ? value.non_field_errors.join(", ")
    : value.non_field_errors ?? JSON.stringify(value);
};

export const handleTimeInputChange = (
  value: string,
  setValue: (val: string) => void,
  setIsError: (isError: boolean) => void,
  setErrorText: (errorText: string | undefined) => void
) => {
  setValue(value);
  const { isValid, errorMsg } = validateTimeInput(value);
  setIsError(!isValid);
  setErrorText(isValid ? undefined : errorMsg);
};
